import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// the style below is a hack to work around kendo react z-index issue causing dropdownlists on forms/windows
// to open behind the form. they promise a fix in upcoming release.
ReactDOM.render(
  <React.StrictMode>
    <App />
    <style>
      {`.k-animation-container {
            z-index: 10003;
        }`}
    </style>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
